import { shipImageBySlug } from "./art-assets.ts";

/** Use only the supplied in-game ship photography in the app. */
export interface ShipArt {
  src: string;
  toon: false;
  accent: null;
}

export function shipArtFor(slug: string | null | undefined): ShipArt | null {
  if (!slug) return null;
  const photo = shipImageBySlug[slug];
  return photo ? { src: photo, toon: false, accent: null } : null;
}
